export enum ProductCode {
    Oto360Insurance = 'CV6',
    Oto360Takaful = 'TV6'
  }
  